export default class formConfig {
  // 招标代理委托-详情
  static configList() {
    return [
      {
        title: "招标人信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "企业名称：",
            value: "prjbuildCorpName",
            type: "input",
            disabled: true,
          },
          {
            label: "社会信用代码：",
            value: "buildCorpNameCode",
            type: "input",
            disabled: true,
            tip: "（组织机构代码）"
          },
        ]
      },
      {
        title: "基本信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "prjName",
            type: "slot",
            slotName: "prjName",
            required: true,
            width: "100%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标代理机构社会信用代码：",
            value: "agencyCorpCode",
            type: "slot",
            slotName: "agencyCorpCode",
            required: true,
            width: "100%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "项目编号：",
            value: "constructionNo",
            type: "input",
            required: true,
            disabled: true,
            tip: "（“项目编号”和“项目名称”从“招标项目选择”中进行选择）",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标代理机构名称：",
            value: "agencyCorpName",
            type: "input",
            required: true,
            disabled: true,
            tip: "（“代理机构名称”和“代理机构社会信用代码”从“代理选择”中进行选择）",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "代理机构法人姓名：",
            value: "agencyCorpLegalPerson",
            type: "input",
            slotName: "agencyCorpLegalPerson",
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          
        ]
      },
      {
        title: "代理内容",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "代理内容：",
            value: "agencyMark",
            type: "textarea",
            width: "100%;",
            class: "formTextarea",
            maxlength: 1200,
            tip: "（可填1200个汉字）",
            disabled: false,
            required: true,
            rule: {
              required: true,
              message: "请输入代理内容",
              trigger: "blur"
            },
          },
        ]
      },
    ];
  }
}
